import React from 'react'

const MyGlammStudio = () => {
  return (
    <div>MyGlammStudio</div>
  )
}

export default MyGlammStudio